/**
 * .893 Oto: „v celom CRM, kde sa zobrazuje nejaká hocijaká cena, nech je
 * vždy napísané, či je cena s DPH alebo bez DPH."
 *
 * Jednotné označenie – všade rovnaký text a vzhľad:
 *   <Dph s />            → malá značka „s DPH"
 *   <Dph bez />          → malá značka „bez DPH"
 *   <CenaDph v={x} s />  → „123,45 € s DPH" (číslo cez money + značka)
 *   dphText(true|false)  → 's DPH' | 'bez DPH' (do hlavičiek stĺpcov, title, textu)
 *
 * Pravidlo: pri hlavičke stĺpca / popise poľa stačí raz (napr. „Cena s DPH"),
 * samostatné číslo bez popisu dostane značku za sebou.
 */
import { money } from '../api';

export const dphText = (sDph) => (sDph ? 's DPH' : 'bez DPH');

export function Dph({ s = false, bez = false, className = '' }) {
  const sDph = s && !bez;
  return (
    <span className={`ml-1 whitespace-nowrap align-middle text-[10px] font-medium uppercase tracking-wide ${sDph ? 'text-slate-400' : 'text-amber-600/80'} ${className}`}>
      {dphText(sDph)}
    </span>
  );
}

export function CenaDph({ v, s = false, bez = false, mena = 'EUR', className = '' }) {
  if (v === null || v === undefined || v === '') return null;
  return <span className={`whitespace-nowrap ${className}`}>{money(v, mena)}<Dph s={s} bez={bez} /></span>;
}

export default Dph;
